export { default as ProductLabel } from './product-label'
export { default as ProductLabels } from './product-labels'
